var map = {
	"./026---SlowOrb.json": 10381,
	"./027---Tornado.json": 50269,
	"./028---KnivesCircle.json": 9892,
	"./029---DamageBuff.json": 12951,
	"./030---LeechBuff.json": 88352,
	"./031---ExtraHeal.json": 24728,
	"./032---BulletKiller.json": 79227,
	"./033---Hook.json": 86475,
	"./034---BackBlink.json": 68001,
	"./035---TimeDistorsion.json": 92400,
	"./036---ToxicCloud.json": 1667,
	"./037---DamageAura.json": 25566,
	"./038---Shockwave.json": 49022,
	"./039---Wings.json": 51110,
	"./040---ComboMult.json": 82161,
	"./041---Pokecharge.json": 1701,
	"./042---Map.json": 9668,
	"./043---Owl.json": 17295,
	"./044---OwlUp.json": 5820,
	"./045---Chicken.json": 53553,
	"./046---SpeedRunner.json": 45259,
	"./047---Dash.json": 85889,
	"./048---BackDash.json": 33159,
	"./049---GiantWhistle.json": 64950,
	"./050---SeismicStomp.json": 52009,
	"./051---CollectorSpin.json": 50459,
	"./052---SmokeBomb.json": 54038,
	"./053---SpawnFriendlyHardy.json": 23068,
	"./054---ExplodeFriendlyHardy.json": 59018,
	"./055---IceArmor.json": 72671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48416;